export const BOND_PRICES_ACTIONS = {
    GET_BOND_PRICES: 'GET_BOND_PRICES',
    GET_BOND_PRICES_REQUEST: 'GET_BOND_PRICES_REQUEST',
    GET_BOND_PRICES_ERROR: 'GET_BOND_PRICES_ERROR'
  };